import { useTheme } from "@mui/material";
import { GridRowIdGetter, GridRowModel } from "@mui/x-data-grid-pro";
import CustomDataGridPro from "components/Common/CustomDataGridPro";
import DataGridColumnGenerator from "components/Common/DataGridColumnGenerator";
import useMessageBox from "helpers/context/Page/useMessageBox";
import useUserInfo from "helpers/context/User/useUserInfo";
import { RoleEnum } from "helpers/enums";
import useIsMobile from "helpers/hooks/useIsMobile";
import { useTranslations } from "@fenetech/translations";
import { IUserSummary } from "helpers/interfaces";
import React, { useMemo } from 'react';
import { userCommandsColumn, userNameColumn } from "./UserColumns";

interface IProps {
    users: IUserSummary[] | null,
    showUserSite: boolean,
    isDealerCreatingAdminContractor: boolean,
    editUser: (employeeID: string) => void,
    deleteUser: (employeeID: string) => void
}

const UserTable: React.FC<IProps> = ({users, showUserSite, isDealerCreatingAdminContractor, editUser, deleteUser}: IProps) => {

    const tm = useTranslations();
    const theme = useTheme();
    const isMobile = useIsMobile();
    const user = useUserInfo();
    const messageBox = useMessageBox();

    const columns = useMemo(() => {
        const generator = new DataGridColumnGenerator(tm, users, theme, isMobile);
        if ((users?.length ?? 0) > 0) {
            generator.AddColumn(userNameColumn("userName", "User Name", tm, isMobile, theme, messageBox));
            generator.TryAddTextColumn("firstName", "First Name", {});
            generator.TryAddTextColumn("lastName", "Last Name", {});
            
            if (showUserSite) {
                generator.TryAddTextColumn("site", "Mfg Site", {});
            }
            generator.AddColumn(userCommandsColumn(tm, editUser, deleteUser, isDealerCreatingAdminContractor, user.HasRole(RoleEnum.Contractor)));
        }
        return generator.GetColumns();
    }, [tm, users, theme, isMobile, messageBox, showUserSite, isDealerCreatingAdminContractor, editUser, deleteUser, user]);
    
    const getRowId: GridRowIdGetter = (row: GridRowModel) => row["employeeID"];

    return <>
        <CustomDataGridPro
            getRowId={getRowId}
            columns={columns}
            rows={users}
            tableName="User"
            tableSubName={isMobile ? "Mobile" : ""}
            hideInMobileColumns={[
                "firstName",
                "lastName",
                "site"
            ]}
        />
    </>;
}

export default UserTable;